module.exports = __webpack_public_path__ + "img/progress6.b8613e8b.png";